<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1746
      1.82187H0.823045C0.368019
      1.82187
      0
      1.45385
      0
      0.998826C0
      0.5438
      0.368019
      0.175781
      0.823045
      0.175781H19.1734C19.6285
      0.175781
      19.9965
      0.5438
      19.9965
      0.998826C19.9965
      1.45385
      19.6285
      1.82187
      19.1746
      1.82187Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconMinus",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
